<template>
    <div class="d-flex flex-wrap w-100 model-grid ms-auto me-auto">
        <TheLoaderComponent v-if="showLoader"></TheLoaderComponent>
        <div class="model-card-block justify-content-center justify-content-lg-end" :key="`model-${product.id}`"
             :id="`model-${product.id}`"
             :class="{'col-lg-4 col-md-6': size === 'small' , 'col-md-6 col-lg-3 ': size !== 'small', 'model-card-block--catalog': place==='gallery'}"
             v-for="(product, index) in products" v-if="products.length > 0">
            <div class="card-model d-flex flex-column justify-content-between" :data-id="product.id"
                 :data-price="product.price">
                <div class="position-relative">
                    <video
                        :src="product.dynamic_img"
                        class="product-image box-shadow-1"
                        @mouseleave="showOnHoverOut(product)"
                        @error="showNoPhotoImage(product)"
                        @click="show3dNewTab(product)"
                        autoplay
                        type="video/mp4"
                        loop
                        :class="{'d-none': product.mouseover === false}"
                    ></video>
                    <img
                        v-if="product.img"
                        :src="showImgModel(product)"
                        @mouseover="showOnHoverBaseModel(product)"
                        alt="model-img"
                        :class="{'d-none': product.mouseover === true}"
                    >

                    <h3 class="title-model mx-4" v-model="descriptionModel = product.name"
                        :data-description="product.name">
                        {{ lang === 'ar-sa' ? product.name : product.name }}</h3>


                    <!--                    <h3 class="title-model mx-4" v-model="descriptionModel = product.description"-->
                    <!--                        :data-description="product.description">-->
                    <!--                        {{ lang === 'ar-sa' ? product.title['ar-sa'] : product.title['en'] }}</h3>-->


                    <!--                    <div class="tags-block d-flex flex-wrap mx-4"  size !== 'smaller'">-->
                    <!--                        <div v-for="tag in product.tags" class="background-hover-tag">-->
                    <!--                            <a :href="tag.slug" @click="tagFilter($event)" class="text-decoration-none js-tags">-->
                    <!--                                <p :data-slug="tag.slug">{{ lang === 'ar-sa' ? tag.title['ar-sa'] : tag.title['en'] }}</p>-->
                    <!--                            </a>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                </div>
                <div class="card-model__block-info">
                    <div class="">
                        <div class="dropdown my-4 w-auto mx-0 js-dropdown-colors dropdown-colors">
                            <p class="w-auto">{{ chooseColor }}</p>
                            <a class="dropdown-toggle px-0 text-decoration-none   js-dropdown navigation-footer"
                               href="#" role="button"
                               data-bs-toggle="dropdown"
                               aria-expanded="false">
                            </a>
                            <ul class="dropdown-menu dropdown-menu-colors">
                                <li class="js-show-color  h-100 show-color" v-model="defaultColor"
                                    @click="addColor($event,color,product)"
                                    v-for="color in (product.material.colors)"
                                    :style="{backgroundColor: color}">
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="mt-auto d-flex align-items-center justify-content-between">
                        <a class="btn-purple px-0 btn col-5 ms-0 me-4"
                           @click="addToCalculation(product.id)"
                           href="#"
                        >{{ findThePrice }} </a>
                        <!--                        <div class="d-flex justify-content-between align-items-center">-->
                        <!--                            <div class="wishlist__icon-block  ms-0 me-1" @click="createWishlist($event, product)">-->
                        <!--                                <img-->
                        <!--                                    :src="product.added_in_wishlist ? '/images/icons/icon-lable-full.svg' : '/images/icons/icon-lable.svg'"-->
                        <!--                                    class="add-cart-icon"-->
                        <!--                                    alt="cart">-->
                        <!--                                &lt;!&ndash;                            <i class="fa-regular fa-bookmark wishlist__icon " @click="createWishlist(product)"></i>&ndash;&gt;-->
                        <!--                            </div>-->
                        <!--                            <div class="like__block d-flex justify-content-center align-items-center"-->
                        <!--                                 :class="{'d-none': showLike}" @click="changeLikesStatus($event,product)">-->
                        <!--                                <img-->
                        <!--                                    :src=" product.liked ?  '/images/icons/icon-like-full.svg' : '/images/icons/icon-like.svg'"-->
                        <!--                                    class="add-cart-icon"-->
                        <!--                                    v-bind:class="{ 'fa-solid' : product.liked}"-->
                        <!--                                    alt="like">-->
                        <!--                            </div>-->

                        <!--                            <img src="../../../../public/images/icons/icon-cart.svg"-->
                        <!--                                 class="add-cart-icon ms-1 me-0 js-add-to-cart"-->
                        <!--                                 @click="addToCart($event,product)" alt="cart">-->
                        <!--                        </div>-->
                    </div>
                </div>

            </div>

        </div>
    </div>

</template>

<script type="application/javascript">
import TheLoaderComponent from "./TheLoaderComponent";

export default {
    components: {TheLoaderComponent},
    name: "CardModelConfiguration",
    props: ['products', 'size', 'place'],
    data() {
        return {
            productsTest: this.products,
            showModal: {type: Boolean, required: true},
            descriptionModel: '',
            showLoader: false,
            arrSlugs: [],
            arrayObjModelToCart: [],
            itemsFromStorage: userId && JSON.parse(localStorage.getItem(`cart-basic-${userId}`)),
            likeStatus: false,
            showLike: autorizetion && autorizetion !== 0,
            disabledMinus: false,
            linkOrderModel: null,
            showMore: 'Show more',
            chooseColor: "Choose color",
            findThePrice: "Find the price",
            lang: window.currentLang,
            titles: {
                description: '',
                material: '',
                color: '',
                layerHeight: '',
                infillPercentage: '',
                count: '',
                price: '',
            },
            countWishList: [],
        }
    },
    updated() {
        autorizetion && autorizetion == 0
        this.changeContent()
    },

    mounted() {
        let vm = this;
        vm.showModal = false;
        this.changeContent()
    },

    methods: {
        addToCalculation(productId) {
            let data = {
                'productId': productId,
            }
            axios.post('/users-models/add-to-calculate', data, {}).then(function (response) {
                window.location.href = "/client-model";
            }).catch(function (error) {
                window.notify('Sorry we have an error on server', 'error')
            })
        },

        // client ---------------------------------------------------------------------------
        showNoPhotoImage(product) {
            product.mouseover = false;
        },
        // clien + base  ---------------------------------------------------------------------------

        showImgModel(product) {
            return product.img;
        },
        showOnHoverBaseModel(product) {
            if (product.file_hash !== undefined) {
                product.mouseover = true;
            }
        },
        showOnHoverOut(product) {
            if (product.file_hash !== undefined) {
                product.mouseover = false;
            }
        },
        show3dNewTab(product) {
            event.preventDefault();
            var params = {
                modelIdentificator: product.file_hash + '_' + product.file_size + '_' + product.color.replace('#',''),
            };
            var queryString = Object.keys(params).map(function(key) {
                return key + '=' + encodeURIComponent(params[key]);
            }).join('&');
            var url =  window.location.protocol
                + '//' + window.location.host
                + '/'+'gallery/3d-preview/'
                + queryString;
            let newTab = window.open(url, '_blank');
            window.o
        },
        changeContent() {
            if (window.currentLang === 'ar-sa') {
                this.lang = 'ar-sa'
                this.showMore = 'أظهر المزيد'
                this.titles.description = 'وصف'
                this.titles.color = 'اللون'
                this.titles.material = 'المواد '
                this.titles.layerHeight = 'دقة الطباعة'
                this.titles.infillPercentage = 'كثافة الحشوة'
                this.titles.count = 'الكمية'
                this.titles.price = 'السعر'
                this.chooseColor = "اختر اللون"
                this.findThePrice = "احسب السعر"


            } else {
                this.lang = 'en'
                this.titles.count = 'Count'
                this.titles.price = 'Price'
                this.titles.priceTotalWithDiscount = 'Price total with discount'
                this.titles.description = 'Description'
                this.titles.color = 'Color'
                this.titles.material = 'Material '
                this.titles.layerHeight = 'Layer height'
                this.titles.infillPercentage = 'Infill percentage'

                this.chooseColor = "Choose color"
                this.showMore = 'Show more'
                this.findThePrice = "Find the price"
            }
        },
        addColor(event, color, product) {

            let oldColor = product.color;
            product.img = product.img.replace(oldColor.replace('#', ''), color.replace('#', ''));
            product.dynamic_img=product.dynamic_img.replace(oldColor.replace('#', ''), color.replace('#', ''));

            let listColors = document.querySelectorAll('.js-show-color')
            let selectMenues = document.querySelectorAll('.dropdown-menu-colors')
            selectMenues.forEach(menu => {
                menu.classList.remove('active')
            });
            product.color = color

            //color choose
            let parent = event.target.closest('.js-dropdown-colors')
            let showColor = parent.querySelector('.js-dropdown ')
            showColor.style.background = color

            listColors.forEach(list => {
                list.classList.remove('border-danger', 'border')
            })
            event.target.classList.add('border-danger', 'border')
            this.colorModel = color
        },
    }
}
</script>

<style lang="scss">
//@import "../../sass/front/card-model";
@import "../../sass/front/user-model";
</style>
